import { AuthService } from '@customer-frontend/auth';
import { logger } from 'utils/logging';

export const authService = new AuthService(
  'pilot_access_token',
  'pilot_user',
  'cookie', // If cookie is disabled, it will fallback to sessionStorage and if sessionStorage is not supported, it will fallback to memory
  logger,
);
